import {gql} from 'apollo-angular';

export function retrieveNotificationsByUserId(fields: string[]) {
  return gql`
    query retrieveNotificationsByUserId($page: Int!, $size: Int!) {
      retrieveNotificationsByUserId(page: $page, size: $size) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function markNotificationsAsRead() {
  return gql`
    mutation markNotificationsAsRead {
      markNotificationsAsRead
    }
  `;
}

export function retrieveEmployeeNotificationOverview(fields: string[]) {
  return gql`
    query retrieveEmployeeNotificationOverview($employeeKeycloakIds: [String!]!) {
      retrieveEmployeeNotificationOverview(employeeKeycloakIds: $employeeKeycloakIds) {
        ${fields.join('\n')}
      }
    }
  `;
}
